import React, { useState, useEffect } from 'react';
import { Search, MapPin, Briefcase, Clock, X, CheckCircle, Phone, Mail } from 'lucide-react';
import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js';
import { getFirestore, collection, addDoc } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js';

import { Button } from 'react-bootstrap';

// Firebase configuration - REPLACE WITH YOUR ACTUAL CONFIG
const firebaseConfig = {
    apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
    authDomain: "olewin-academy.firebaseapp.com",
    projectId: "olewin-academy",
    storageBucket: "olewin-academy.appspot.com",
    messagingSenderId: "622543323365",
    appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
    measurementId: "G-09WHHRMJRC"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const JobsPortal = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    experience: '',
    currentCompany: '',
    currentRole: '',
    noticePeriod: '',
    expectedSalary: '',
    portfolio: '',
    linkedin: '',
    github: '',
    skills: '',
    whyJoin: '',
    jobRole: ''
  });

  const contactNumber = "+91-8639449423";
  const contactEmail = "olewinacademy@gmail.com";

  const jobListings = [
    {
      id: 1,
      title: "Senior SDE-2 (Full Stack Developer)",
      department: "Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "We're looking for an experienced SDE-2 to lead development of our Ed-Tech platform with cutting-edge technologies.",
      responsibilities: [
        "Design and develop scalable web applications using React, Node.js, and modern frameworks",
        "Lead technical discussions and mentor junior developers",
        "Implement microservices architecture and RESTful APIs",
        "Optimize application performance and database queries",
        "Collaborate with cross-functional teams for feature development",
        "Participate in code reviews and maintain code quality standards"
      ],
      requirements: [
        "3-5 years of experience in full-stack development",
        "Strong proficiency in React.js, Node.js, Express.js",
        "Experience with MongoDB, PostgreSQL, or MySQL",
        "Knowledge of AWS, Docker, and CI/CD pipelines",
        "Understanding of system design and architecture patterns",
        "Excellent problem-solving and communication skills"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["React.js", "Node.js", "MongoDB", "AWS", "Docker", "System Design"]
    },
    {
      id: 2,
      title: "Web Developer (React.js Specialist)",
      department: "Frontend Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Join our frontend team to build intuitive and responsive user interfaces for our learning platform.",
      responsibilities: [
        "Develop responsive web applications using React.js and modern CSS frameworks",
        "Implement pixel-perfect designs from Figma/Adobe XD",
        "Optimize web applications for maximum speed and scalability",
        "Integrate RESTful APIs and GraphQL endpoints",
        "Implement state management using Redux/Context API",
        "Ensure cross-browser compatibility and accessibility standards"
      ],
      requirements: [
        "2-4 years of experience in React.js development",
        "Strong understanding of HTML5, CSS3, JavaScript (ES6+)",
        "Experience with responsive design and mobile-first approach",
        "Proficiency in state management libraries (Redux, MobX)",
        "Knowledge of testing frameworks (Jest, React Testing Library)",
        "Familiarity with version control systems (Git)"
      ],
      qualifications: "B.Tech/B.E/MCA or equivalent",
      skills: ["React.js", "JavaScript", "HTML5", "CSS3", "Redux", "TypeScript"]
    },
    {
      id: 3,
      title: "Mobile App Developer (Android/IOS) (Flutter)",
      department: "Mobile Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Build cross-platform mobile applications for our Ed-Tech platform reaching millions of students.",
      responsibilities: [
        "Develop and maintain React Native mobile applications for iOS and Android",
        "Implement native modules and integrate third-party libraries",
        "Optimize app performance and reduce bundle size",
        "Work with native iOS (Swift) and Android (Kotlin) when needed",
        "Implement push notifications and deep linking",
        "Collaborate with UI/UX designers for seamless user experience"
      ],
      requirements: [
        "3-5 years of experience in mobile app development",
        "Strong proficiency in React Native and JavaScript",
        "Experience with native iOS and Android development",
        "Knowledge of mobile app deployment processes (App Store, Play Store)",
        "Understanding of mobile UI/UX best practices",
        "Experience with mobile app testing frameworks"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["React Native", "JavaScript", "iOS", "Android", "Redux", "Firebase"]
    },
    {
      id: 4,
      title: "DevOps Engineer",
      department: "Infrastructure",
      location: "Remote",
      type: "Full-time",
      experience: "3-6 years",
      description: "Manage and optimize our cloud infrastructure to ensure high availability and scalability.",
      responsibilities: [
        "Design and implement CI/CD pipelines using Jenkins, GitLab CI, or GitHub Actions",
        "Manage cloud infrastructure on AWS, Azure, and GCP",
        "Implement infrastructure as code using Terraform or CloudFormation",
        "Monitor system performance and implement logging solutions",
        "Automate deployment processes and configuration management",
        "Ensure security best practices and compliance standards"
      ],
      requirements: [
        "3-6 years of experience in DevOps or Site Reliability Engineering",
        "Strong knowledge of AWS, Azure, or GCP services",
        "Experience with containerization (Docker, Kubernetes)",
        "Proficiency in scripting languages (Bash, Python)",
        "Knowledge of monitoring tools (Prometheus, Grafana, ELK)",
        "Understanding of networking and security principles"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["AWS", "Docker", "Kubernetes", "Terraform", "Jenkins", "Python"]
    },
    {
      id: 5,
      title: "LLM Developer (Large Language Models)",
      department: "AI/ML",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-5 years",
      description: "Develop and fine-tune LLM-based applications for personalized learning experiences.",
      responsibilities: [
        "Develop applications using OpenAI, Anthropic, and open-source LLMs",
        "Fine-tune and optimize language models for educational use cases",
        "Implement prompt engineering strategies and RAG systems",
        "Build conversational AI interfaces and chatbots",
        "Optimize model performance and reduce latency",
        "Stay updated with latest LLM research and implementations"
      ],
      requirements: [
        "2-5 years of experience in NLP or AI development",
        "Strong understanding of transformer architectures and LLMs",
        "Experience with OpenAI API, Langchain, or LlamaIndex",
        "Proficiency in Python and ML frameworks (PyTorch, TensorFlow)",
        "Knowledge of vector databases (Pinecone, Weaviate, Chroma)",
        "Understanding of prompt engineering and fine-tuning techniques"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science, AI, or related field",
      skills: ["Python", "LLMs", "Langchain", "RAG", "Vector DB", "Prompt Engineering"]
    },
    {
      id: 6,
      title: "AI/ML Engineer",
      department: "AI/ML",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-6 years",
      description: "Build intelligent systems and recommendation engines to enhance student learning outcomes.",
      responsibilities: [
        "Develop and deploy machine learning models for recommendation systems",
        "Build computer vision models for content analysis",
        "Implement NLP solutions for automated assessment",
        "Create predictive models for student performance analytics",
        "Optimize model training pipelines and MLOps workflows",
        "Collaborate with data engineers for data pipeline development"
      ],
      requirements: [
        "3-6 years of experience in machine learning engineering",
        "Strong proficiency in Python and ML frameworks (TensorFlow, PyTorch, scikit-learn)",
        "Experience with deep learning and neural network architectures",
        "Knowledge of MLOps tools and model deployment",
        "Understanding of statistical analysis and data preprocessing",
        "Experience with cloud ML services (AWS SageMaker, Azure ML)"
      ],
      qualifications: "B.Tech/M.Tech/PhD in Computer Science, AI/ML, or related field",
      skills: ["Python", "TensorFlow", "PyTorch", "MLOps", "Deep Learning", "NLP"]
    },
    {
      id: 7,
      title: "Multi-Cloud Engineer",
      department: "Cloud Infrastructure",
      location: "Remote",
      type: "Full-time",
      experience: "4-7 years",
      description: "Design and manage multi-cloud architecture across AWS, Azure, and GCP.",
      responsibilities: [
        "Design multi-cloud architecture for high availability and disaster recovery",
        "Implement cloud cost optimization strategies",
        "Manage cloud security and compliance across platforms",
        "Migrate applications between cloud providers",
        "Automate cloud resource provisioning and management",
        "Provide technical guidance on cloud-native technologies"
      ],
      requirements: [
        "4-7 years of experience in cloud engineering",
        "Certifications in AWS, Azure, and/or GCP (preferred)",
        "Experience with multi-cloud management tools",
        "Strong knowledge of cloud networking and security",
        "Proficiency in IaC tools (Terraform, Pulumi)",
        "Understanding of FinOps and cloud cost management"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["AWS", "Azure", "GCP", "Terraform", "Cloud Security", "FinOps"]
    },
    {
      id: 8,
      title: "System Design & Architecture Engineer",
      department: "Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "5-8 years",
      description: "Lead system design initiatives and architect scalable solutions for our Ed-Tech platform.",
      responsibilities: [
        "Design high-level and low-level system architecture",
        "Define technical standards and best practices",
        "Conduct architecture reviews and technical assessments",
        "Design microservices architecture and distributed systems",
        "Create scalability and performance optimization strategies",
        "Mentor engineering teams on architectural principles"
      ],
      requirements: [
        "5-8 years of experience in software engineering and architecture",
        "Strong understanding of distributed systems and microservices",
        "Experience with designing scalable systems (handling millions of users)",
        "Knowledge of database design, caching strategies, and message queues",
        "Excellent communication and documentation skills",
        "Experience with architectural patterns and design principles"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science or related field",
      skills: ["System Design", "Microservices", "Distributed Systems", "Architecture Patterns", "Scalability", "Documentation"]
    },
    {
      id: 9,
      title: "Agentic AI Developer",
      department: "AI/ML",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build autonomous AI agents for intelligent tutoring and student support systems.",
      responsibilities: [
        "Develop multi-agent systems using LangGraph, AutoGPT, or similar frameworks",
        "Implement autonomous agents for educational assistance",
        "Design agent workflows and decision-making processes",
        "Integrate agents with external tools and APIs",
        "Optimize agent performance and reasoning capabilities",
        "Research and implement latest agentic AI techniques"
      ],
      requirements: [
        "2-4 years of experience in AI/ML development",
        "Experience with agentic frameworks (LangGraph, AutoGPT, CrewAI)",
        "Strong understanding of LLMs and prompt engineering",
        "Proficiency in Python and async programming",
        "Knowledge of agent architectures (ReAct, Plan-and-Execute)",
        "Experience with tool integration and function calling"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science, AI, or related field",
      skills: ["Python", "LangGraph", "Agentic AI", "LLMs", "AutoGPT", "Multi-Agent Systems"]
    },
    {
      id: 10,
      title: "RAG Systems Engineer",
      department: "AI/ML",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-5 years",
      description: "Build Retrieval-Augmented Generation systems for intelligent content delivery.",
      responsibilities: [
        "Design and implement RAG pipelines for educational content",
        "Optimize document chunking and embedding strategies",
        "Implement semantic search and hybrid retrieval systems",
        "Fine-tune retrieval models and reranking algorithms",
        "Build knowledge bases using vector databases",
        "Evaluate and improve RAG system performance"
      ],
      requirements: [
        "2-5 years of experience in NLP or information retrieval",
        "Strong understanding of RAG architectures and techniques",
        "Experience with vector databases (Pinecone, Weaviate, Qdrant)",
        "Proficiency in Python and NLP libraries",
        "Knowledge of embedding models and semantic search",
        "Experience with evaluation metrics and benchmarking"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science or related field",
      skills: ["Python", "RAG", "Vector Databases", "Embeddings", "Semantic Search", "LLMs"]
    },
    {
      id: 11,
      title: "Backend Developer (Node.js)",
      department: "Backend Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-5 years",
      description: "Develop robust backend services and APIs for our learning management system.",
      responsibilities: [
        "Design and develop RESTful and GraphQL APIs",
        "Implement authentication and authorization mechanisms",
        "Optimize database queries and data models",
        "Build scalable microservices architecture",
        "Implement caching strategies using Redis",
        "Write comprehensive unit and integration tests"
      ],
      requirements: [
        "2-5 years of experience in backend development",
        "Strong proficiency in Node.js and Express.js",
        "Experience with databases (MongoDB, PostgreSQL)",
        "Knowledge of message queues (RabbitMQ, Kafka)",
        "Understanding of API design and best practices",
        "Experience with testing frameworks (Jest, Mocha)"
      ],
      qualifications: "B.Tech/B.E/MCA in Computer Science or related field",
      skills: ["Node.js", "Express.js", "MongoDB", "PostgreSQL", "Redis", "GraphQL"]
    },
    {
      id: 12,
      title: "Frontend Developer (web 3.0 / D-Apps)",
      department: "Frontend Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build interactive user interfaces using web 3.0 for our admin dashboard and tools.",
      responsibilities: [
        "Develop single-page applications using Vue.js 3",
        "Implement component-based architecture",
        "Integrate with backend APIs and manage state",
        "Optimize application performance and bundle size",
        "Write unit tests using Vue Test Utils",
        "Collaborate with designers for UI/UX implementation"
      ],
      requirements: [
        "2-4 years of experience in frontend development",
        "Strong proficiency in Vue.js and JavaScript",
        "Experience with state management (Vuex, Pinia)",
        "Knowledge of Vue Router and Vue CLI",
        "Understanding of modern frontend build tools",
        "Experience with TypeScript (preferred)"
      ],
      qualifications: "B.Tech/B.E or equivalent",
      skills: ["Vue.js", "JavaScript", "Vuex", "TypeScript", "HTML5", "CSS3"]
    },
    {
      id: 13,
      title: "Data Engineer",
      department: "Data Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "3-6 years",
      description: "Build and maintain data pipelines for analytics and machine learning workflows.",
      responsibilities: [
        "Design and implement ETL/ELT data pipelines",
        "Build data warehouses and data lakes",
        "Optimize data storage and retrieval systems",
        "Implement data quality and monitoring frameworks",
        "Collaborate with ML teams for feature engineering",
        "Manage big data processing using Spark or similar tools"
      ],
      requirements: [
        "3-6 years of experience in data engineering",
        "Strong proficiency in Python and SQL",
        "Experience with data pipeline tools (Airflow, Prefect)",
        "Knowledge of cloud data services (AWS Redshift, BigQuery)",
        "Understanding of data modeling and warehousing concepts",
        "Experience with big data technologies (Spark, Hadoop)"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science or related field",
      skills: ["Python", "SQL", "Airflow", "Spark", "AWS", "Data Modeling"]
    },
    {
      id: 14,
      title: "Computer Vision Engineer",
      department: "AI/ML",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Develop computer vision solutions for automated content analysis and proctoring.",
      responsibilities: [
        "Develop object detection and image classification models",
        "Implement facial recognition and gesture detection systems",
        "Build OCR solutions for document processing",
        "Optimize model inference for real-time applications",
        "Deploy models using TensorFlow Serving or ONNX",
        "Research and implement state-of-the-art CV techniques"
      ],
      requirements: [
        "3-5 years of experience in computer vision",
        "Strong proficiency in OpenCV, TensorFlow, or PyTorch",
        "Experience with CNN architectures (ResNet, YOLO, etc.)",
        "Knowledge of image processing and augmentation techniques",
        "Understanding of model optimization and deployment",
        "Experience with video processing and real-time systems"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science, AI, or related field",
      skills: ["Python", "OpenCV", "TensorFlow", "PyTorch", "Computer Vision", "Deep Learning"]
    },
    {
      id: 15,
      title: "QA Automation Engineer",
      department: "Quality Assurance",
      location: "Remote",
      type: "Full-time",
      experience: "3-5 years",
      description: "Build and maintain automated testing frameworks to ensure product quality.",
      responsibilities: [
        "Design and implement automated test frameworks",
        "Write and maintain test scripts for web and mobile applications",
        "Implement CI/CD integration for automated testing",
        "Perform API testing and performance testing",
        "Conduct security and penetration testing",
        "Create and maintain test documentation"
      ],
      requirements: [
        "3-5 years of experience in QA automation",
        "Strong knowledge of Selenium, Cypress, or Playwright",
        "Experience with API testing tools (Postman, REST Assured)",
        "Proficiency in programming languages (Python, JavaScript)",
        "Knowledge of performance testing tools (JMeter, Gatling)",
        "Understanding of CI/CD pipelines and testing strategies"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Selenium", "Cypress", "Python", "API Testing", "CI/CD", "Test Automation"]
    },
    {
      id: 16,
      title: "UI/UX Developer (Quantum Applications/Satellite Communications Systems",
      department: "Design & Frontend ",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Create intuitive and beautiful user interfaces with focus on user experience.",
      responsibilities: [
        "Design and implement responsive user interfaces",
        "Create interactive prototypes and wireframes",
        "Implement design systems and component libraries",
        "Conduct user research and usability testing",
        "Collaborate with designers to implement pixel-perfect designs",
        "Optimize user flows and conversion rates"
      ],
      requirements: [
        "2-4 years of experience in UI/UX development",
        "Strong proficiency in HTML, CSS, JavaScript",
        "Experience with design tools (Figma, Adobe XD)",
        "Knowledge of accessibility standards (WCAG)",
        "Understanding of design principles and user psychology",
        "Portfolio demonstrating UI/UX work"
      ],
      qualifications: "B.Tech/B.E/B.Des or equivalent",
      skills: ["HTML5", "CSS3", "JavaScript", "Figma", "UX Design", "Accessibility"]
    },
    {
      id: 17,
      title: "Database Administrator",
      department: "Infrastructure",
      location: "Remote",
      type: "Full-time",
      experience: "4-7 years",
      description: "Manage and optimize database systems ensuring high availability and performance.",
      responsibilities: [
        "Manage and maintain production databases (MySQL, PostgreSQL, MongoDB)",
        "Implement backup and disaster recovery strategies",
        "Optimize database queries and indexing strategies",
        "Monitor database performance and troubleshoot issues",
        "Implement database security and access controls",
        "Plan and execute database migrations and upgrades"
      ],
      requirements: [
        "4-7 years of experience as a Database Administrator",
        "Strong knowledge of SQL and NoSQL databases",
        "Experience with database replication and clustering",
        "Proficiency in performance tuning and optimization",
        "Knowledge of database backup and recovery procedures",
        "Understanding of database security best practices"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["MySQL", "PostgreSQL", "MongoDB", "Database Optimization", "Backup & Recovery", "SQL"]
    },
    {
      id: 18,
      title: "Security Engineer",
      department: "Security",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-6 years",
      description: "Ensure the security of our platform and protect user data from threats.",
      responsibilities: [
        "Conduct security assessments and penetration testing",
        "Implement security controls and monitoring systems",
        "Respond to security incidents and vulnerabilities",
        "Develop security policies and best practices",
        "Perform code reviews for security vulnerabilities",
        "Stay updated with latest security threats and trends"
      ],
      requirements: [
        "3-6 years of experience in cybersecurity",
        "Strong knowledge of OWASP Top 10 and security frameworks",
        "Experience with penetration testing tools",
        "Understanding of network security and encryption",
        "Knowledge of compliance standards (GDPR, SOC 2)",
        "Relevant certifications (CEH, CISSP) preferred"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Cybersecurity", "Penetration Testing", "OWASP", "Network Security", "Compliance", "Security Auditing"]
    },
    {
      id: 19,
      title: "Product Manager (Tech)",
      department: "Product Management",
      location: "Hybrid",
      type: "Full-time",
      experience: "4-7 years",
      description: "Drive product strategy and roadmap for our Ed-Tech platform.",
      responsibilities: [
        "Define product vision and strategy",
        "Gather and prioritize product requirements",
        "Work with engineering teams on product development",
        "Conduct market research and competitive analysis",
        "Define and track product metrics and KPIs",
        "Collaborate with stakeholders across the organization"
      ],
      requirements: [
        "4-7 years of experience in product management",
        "Strong understanding of Ed-Tech industry",
        "Technical background with understanding of software development",
        "Excellent communication and stakeholder management skills",
        "Experience with product analytics tools",
        "MBA or technical degree preferred"
      ],
      qualifications: "B.Tech/MBA or equivalent",
      skills: ["Product Strategy", "Roadmap Planning", "Analytics", "Stakeholder Management", "Ed-Tech", "Agile"]
    },
    {
      id: 20,
      title: "Solutions Architect",
      department: "Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "5-8 years",
      description: "Design end-to-end solutions for enterprise clients and complex technical requirements.",
      responsibilities: [
        "Design comprehensive technical solutions for clients",
        "Create architecture diagrams and technical documentation",
        "Provide technical consultation to sales and implementation teams",
        "Evaluate and recommend technologies and tools",
        "Conduct technical workshops and presentations",
        "Ensure solutions align with best practices and standards"
      ],
      requirements: [
        "5-8 years of experience in software engineering and architecture",
        "Strong knowledge of cloud platforms and modern architectures",
        "Excellent presentation and communication skills",
        "Experience with enterprise software solutions",
        "Understanding of integration patterns and APIs",
        "Relevant certifications (AWS SA, Azure Architect) preferred"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science or related field",
      skills: ["Solution Architecture", "Cloud Platforms", "Enterprise Architecture", "Technical Consulting", "Documentation", "Presentations"]
    },
    {
      id: 21,
      title: "Junior Full Stack Developer",
      department: "Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "0-1 year (Freshers with internship)",
      description: "Start your career building full-stack applications in a collaborative environment.",
      responsibilities: [
        "Develop features for web applications under senior guidance",
        "Write clean, maintainable code following best practices",
        "Participate in code reviews and team discussions",
        "Debug and fix issues in existing applications",
        "Learn and implement new technologies",
        "Collaborate with cross-functional teams"
      ],
      requirements: [
        "0-1 year of experience or strong internship experience",
        "Knowledge of React.js, Node.js, and databases",
        "Understanding of HTML, CSS, JavaScript fundamentals",
        "Familiarity with Git and version control",
        "Strong problem-solving skills and eagerness to learn",
        "Completed projects or internships in web development"
      ],
      qualifications: "B.Tech/B.E/MCA (2023-2024 graduates)",
      skills: ["React.js", "Node.js", "JavaScript", "HTML/CSS", "Git", "Problem Solving"]
    },
    {
      id: 22,
      title: "AI Research Intern",
      department: "AI/ML",
      location: "Hybrid",
      type: "Internship",
      experience: "0-1 year (Freshers/Students)",
      description: "Work on cutting-edge AI research projects and contribute to innovation.",
      responsibilities: [
        "Assist in AI/ML research projects",
        "Implement research papers and experiments",
        "Collect and analyze data for model training",
        "Document findings and create presentations",
        "Collaborate with research team on publications",
        "Stay updated with latest AI research"
      ],
      requirements: [
        "Currently pursuing or recently completed B.Tech/M.Tech",
        "Strong foundation in mathematics and statistics",
        "Knowledge of Python and ML libraries",
        "Understanding of neural networks and deep learning",
        "Published research papers or academic projects (preferred)",
        "Passion for AI and continuous learning"
      ],
      qualifications: "B.Tech/M.Tech in Computer Science, AI, or pursuing",
      skills: ["Python", "Machine Learning", "Research", "TensorFlow/PyTorch", "Mathematics", "Academic Writing"]
    },
    {
      id: 23,
      title: "Flutter App Developer",
      department: "Mobile Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build beautiful cross-platform mobile applications using Flutter.",
      responsibilities: [
        "Develop mobile applications using Flutter and Dart",
        "Implement responsive UI designs",
        "Integrate REST APIs and handle state management",
        "Optimize app performance and reduce load times",
        "Write unit and widget tests",
        "Publish apps to App Store and Play Store"
      ],
      requirements: [
        "2-4 years of Flutter development experience",
        "Strong proficiency in Dart programming language",
        "Experience with state management (Provider, Riverpod, Bloc)",
        "Knowledge of Firebase services",
        "Understanding of mobile app lifecycle and architecture",
        "Portfolio of published Flutter apps"
      ],
      qualifications: "B.Tech/B.E or equivalent",
      skills: ["Flutter", "Dart", "Firebase", "State Management", "Mobile UI", "REST API"]
    },
    {
      id: 24,
      title: "Python Backend (AI/ML) Developer",
      department: "Backend Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-5 years",
      description: "Build scalable backend services using Python and modern frameworks.",
      responsibilities: [
        "Develop RESTful APIs using Django or FastAPI",
        "Implement business logic and data processing",
        "Optimize database queries and implement caching",
        "Write comprehensive tests and documentation",
        "Integrate third-party services and APIs",
        "Debug and resolve production issues"
      ],
      requirements: [
        "2-5 years of Python backend development experience",
        "Strong knowledge of Django or FastAPI",
        "Experience with PostgreSQL or MySQL",
        "Understanding of async programming and concurrency",
        "Knowledge of REST API design principles",
        "Familiarity with Docker and cloud platforms"
      ],
      qualifications: "B.Tech/B.E/MCA in Computer Science or related field",
      skills: ["Python", "Django", "FastAPI", "PostgreSQL", "Redis", "Docker"]
    },
    {
      id: 25,
      title: "Blockchain Developer",
      department: "Emerging Technologies",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Develop blockchain solutions for certificate verification and credential management.",
      responsibilities: [
        "Develop smart contracts using Solidity",
        "Build decentralized applications (DApps)",
        "Implement blockchain-based certificate verification",
        "Integrate Web3 technologies with existing platforms",
        "Optimize gas costs and contract security",
        "Stay updated with blockchain trends and protocols"
      ],
      requirements: [
        "2-4 years of blockchain development experience",
        "Strong proficiency in Solidity and Ethereum",
        "Experience with Web3.js or Ethers.js",
        "Knowledge of smart contract security best practices",
        "Understanding of consensus mechanisms and protocols",
        "Familiarity with IPFS and decentralized storage"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Solidity", "Ethereum", "Web3.js", "Smart Contracts", "Blockchain", "DApps"]
    },
    {
      id: 26,
      title: "Data Scientist",
      department: "Data Science",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Analyze educational data to drive insights and improve learning outcomes.",
      responsibilities: [
        "Build predictive models for student performance",
        "Conduct A/B testing and statistical analysis",
        "Create data visualizations and dashboards",
        "Develop recommendation algorithms",
        "Collaborate with product teams on data-driven features",
        "Present insights to stakeholders"
      ],
      requirements: [
        "3-5 years of experience in data science",
        "Strong proficiency in Python and R",
        "Experience with ML libraries (scikit-learn, pandas, numpy)",
        "Knowledge of statistical analysis and hypothesis testing",
        "Proficiency in data visualization tools (Tableau, Power BI)",
        "Experience with SQL and big data technologies"
      ],
      qualifications: "B.Tech/M.Tech/PhD in Computer Science, Statistics, or related field",
      skills: ["Python", "R", "Machine Learning", "Statistics", "SQL", "Data Visualization"]
    },
    {
      id: 27,
      title: "Platform Engineer",
      department: "Infrastructure",
      location: "Remote",
      type: "Full-time",
      experience: "4-6 years",
      description: "Build and maintain internal developer platforms and tools.",
      responsibilities: [
        "Design and build internal developer platforms",
        "Implement self-service infrastructure provisioning",
        "Develop CLI tools and automation scripts",
        "Create documentation and runbooks",
        "Improve developer experience and productivity",
        "Maintain platform reliability and uptime"
      ],
      requirements: [
        "4-6 years of experience in platform or infrastructure engineering",
        "Strong knowledge of Kubernetes and container orchestration",
        "Experience with IaC tools (Terraform, Pulumi)",
        "Proficiency in Go, Python, or similar languages",
        "Understanding of GitOps and CI/CD practices",
        "Experience building internal tools and platforms"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Kubernetes", "Terraform", "Go", "Platform Engineering", "GitOps", "Automation"]
    },
    {
      id: 28,
      title: "Technical Writer",
      department: "Documentation",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Create comprehensive technical documentation for developers and users.",
      responsibilities: [
        "Write API documentation and developer guides",
        "Create user manuals and tutorials",
        "Maintain documentation repositories",
        "Collaborate with engineering teams",
        "Review and edit technical content",
        "Implement documentation best practices"
      ],
      requirements: [
        "2-4 years of technical writing experience",
        "Strong understanding of software development",
        "Experience with documentation tools (GitBook, Docusaurus)",
        "Proficiency in Markdown and documentation as code",
        "Excellent written communication skills",
        "Ability to explain complex technical concepts simply"
      ],
      qualifications: "B.Tech/B.E or equivalent with strong writing skills",
      skills: ["Technical Writing", "Documentation", "Markdown", "API Documentation", "Communication", "Editing"]
    },
    {
      id: 29,
      title: "Content Developer (EdTech)",
      department: "Content",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Create engaging educational content and course materials.",
      responsibilities: [
        "Develop course content and curriculum",
        "Create interactive learning materials",
        "Write assessments and quiz questions",
        "Collaborate with subject matter experts",
        "Ensure content quality and accuracy",
        "Stay updated with educational trends"
      ],
      requirements: [
        "2-4 years of content development experience",
        "Strong subject matter expertise in technology",
        "Experience in educational content creation",
        "Excellent writing and communication skills",
        "Knowledge of instructional design principles",
        "Familiarity with LMS platforms"
      ],
      qualifications: "B.Tech/B.E with teaching or content creation experience",
      skills: ["Content Writing", "Curriculum Design", "Instructional Design", "EdTech", "Communication", "LMS"]
    },
    {
      id: 30,
      title: "Video Production Specialist (Vision Studio Models)",
      department: "Media Production",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Produce high-quality educational videos and multimedia content.",
      responsibilities: [
        "Record and edit educational videos",
        "Create animations and motion graphics",
        "Manage video production workflow",
        "Optimize videos for different platforms",
        "Collaborate with instructors and content team",
        "Maintain video quality standards"
      ],
      requirements: [
        "2-4 years of video production experience",
        "Proficiency in Adobe Premiere, After Effects",
        "Experience with video editing and color grading",
        "Knowledge of animation and motion graphics",
        "Understanding of video optimization and encoding",
        "Portfolio of video production work"
      ],
      qualifications: "B.Des/B.Tech or relevant degree",
      skills: ["Video Editing", "Adobe Premiere", "After Effects", "Motion Graphics", "Animation", "Video Production"]
    },
    {
      id: 31,
      title: "Business Analyst",
      department: "Business Intelligence",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Analyze business processes and provide data-driven recommendations.",
      responsibilities: [
        "Gather and analyze business requirements",
        "Create business process documentation",
        "Develop reports and dashboards",
        "Conduct gap analysis and feasibility studies",
        "Facilitate meetings with stakeholders",
        "Monitor KPIs and business metrics"
      ],
      requirements: [
        "3-5 years of business analysis experience",
        "Strong analytical and problem-solving skills",
        "Experience with SQL and data analysis tools",
        "Knowledge of Agile and Scrum methodologies",
        "Excellent presentation and communication skills",
        "Proficiency in Excel, PowerPoint, and BI tools"
      ],
      qualifications: "B.Tech/MBA or equivalent",
      skills: ["Business Analysis", "SQL", "Data Analysis", "Stakeholder Management", "Agile", "BI Tools"]
    },
    {
      id: 32,
      title: "Game Developer (Multi-platform)",
      department: "Game Development",
      location: "Remote",
      type: "Full-time",
      experience: "2-5 years",
      description: "Create engaging educational games to enhance learning experiences.",
      responsibilities: [
        "Develop educational games using Unity or Unreal Engine",
        "Implement game mechanics and physics",
        "Integrate learning objectives into gameplay",
        "Optimize game performance across platforms",
        "Create game assets and animations",
        "Collaborate with educators on game design"
      ],
      requirements: [
        "2-5 years of game development experience",
        "Strong proficiency in Unity or Unreal Engine",
        "Experience with C# or C++ programming",
        "Knowledge of game design principles",
        "Understanding of educational game mechanics",
        "Portfolio of completed game projects"
      ],
      qualifications: "B.Tech/B.E in Computer Science or Game Development",
      skills: ["Unity", "C#", "Game Development", "Game Design", "Animation", "Physics"]
    },
    {
      id: 33,
      title: "AR/VR Developer",
      department: "Immersive Technologies",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build immersive AR/VR experiences for interactive learning.",
      responsibilities: [
        "Develop AR/VR applications for educational content",
        "Implement 3D interactions and spatial computing",
        "Optimize performance for VR headsets and mobile AR",
        "Create immersive learning environments",
        "Integrate haptic feedback and audio",
        "Test and iterate on user experience"
      ],
      requirements: [
        "2-4 years of AR/VR development experience",
        "Experience with Unity and AR/VR SDKs",
        "Knowledge of ARKit, ARCore, or WebXR",
        "Understanding of 3D mathematics and physics",
        "Experience with VR headsets (Oculus, HTC Vive)",
        "Portfolio of AR/VR projects"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Unity", "AR/VR", "ARKit", "ARCore", "3D Development", "Spatial Computing"]
    },
    {
      id: 34,
      title: "Growth Hacker",
      department: "Growth & Marketing",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Drive user acquisition and engagement through data-driven strategies.",
      responsibilities: [
        "Develop and execute growth experiments",
        "Analyze user data and identify growth opportunities",
        "Optimize conversion funnels and user journeys",
        "Implement A/B testing and analytics",
        "Create viral marketing campaigns",
        "Collaborate with product and marketing teams"
      ],
      requirements: [
        "2-4 years of growth hacking experience",
        "Strong analytical and data-driven mindset",
        "Experience with analytics tools (Google Analytics, Mixpanel)",
        "Knowledge of SEO, SEM, and digital marketing",
        "Understanding of user psychology and behavior",
        "Proven track record of driving growth"
      ],
      qualifications: "B.Tech/MBA or equivalent",
      skills: ["Growth Hacking", "Analytics", "A/B Testing", "SEO", "Digital Marketing", "Data Analysis"]
    },
    {
      id: 35,
      title: "Scrum Master",
      department: "Agile Delivery",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-6 years",
      description: "Facilitate Agile processes and remove impediments for development teams.",
      responsibilities: [
        "Facilitate Scrum ceremonies (daily standups, sprint planning, retrospectives)",
        "Coach teams on Agile practices",
        "Remove blockers and impediments",
        "Track team velocity and sprint metrics",
        "Foster continuous improvement culture",
        "Collaborate with product owners and stakeholders"
      ],
      requirements: [
        "3-6 years of Scrum Master experience",
        "CSM or PSM certification required",
        "Strong understanding of Agile methodologies",
        "Excellent facilitation and coaching skills",
        "Experience with Jira or similar tools",
        "Ability to work with distributed teams"
      ],
      qualifications: "B.Tech/B.E or equivalent with Scrum certification",
      skills: ["Scrum", "Agile", "Facilitation", "Coaching", "Jira", "Team Management"]
    },
    {
      id: 36,
      title: "Site Reliability Engineer (SRE)",
      department: "Infrastructure",
      location: "Remote",
      type: "Full-time",
      experience: "3-6 years",
      description: "Ensure reliability, availability, and performance of production systems.",
      responsibilities: [
        "Design and implement monitoring and alerting systems",
        "Manage incident response and post-mortems",
        "Implement SLIs, SLOs, and error budgets",
        "Automate operational tasks and runbooks",
        "Optimize system performance and scalability",
        "Participate in on-call rotation"
      ],
      requirements: [
        "3-6 years of SRE or operations experience",
        "Strong knowledge of Linux systems and networking",
        "Experience with monitoring tools (Prometheus, Grafana)",
        "Proficiency in scripting (Python, Bash)",
        "Understanding of distributed systems",
        "Experience with incident management"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["SRE", "Linux", "Monitoring", "Python", "Incident Management", "Distributed Systems"]
    },
    {
      id: 37,
      title: "API Developer ( Super Intelligence Models)",
      department: "Backend Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-5 years",
      description: "Design and develop robust APIs for internal and external consumption.",
      responsibilities: [
        "Design RESTful and GraphQL APIs",
        "Implement API authentication and rate limiting",
        "Create comprehensive API documentation",
        "Optimize API performance and caching",
        "Version and deprecate APIs properly",
        "Monitor API usage and analytics"
      ],
      requirements: [
        "2-5 years of API development experience",
        "Strong knowledge of REST and GraphQL",
        "Experience with Node.js, Python, or Java",
        "Understanding of API design best practices",
        "Knowledge of API security (OAuth, JWT)",
        "Experience with API gateways and management tools"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["REST API", "GraphQL", "Node.js", "API Design", "OAuth", "API Security"]
    },
    {
      id: 38,
      title: "Chatbot Developer (Automation)",
      department: "AI/ML",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build intelligent chatbots for student support and engagement.",
      responsibilities: [
        "Develop conversational AI chatbots",
        "Implement NLU and intent recognition",
        "Design conversation flows and dialog management",
        "Integrate chatbots with messaging platforms",
        "Train and improve chatbot responses",
        "Monitor chatbot performance and user satisfaction"
      ],
      requirements: [
        "2-4 years of chatbot development experience",
        "Experience with NLP frameworks (Rasa, Dialogflow)",
        "Knowledge of LLMs and conversational AI",
        "Proficiency in Python and NLP libraries",
        "Understanding of chatbot UX best practices",
        "Experience with messaging platform APIs"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["NLP", "Chatbots", "Python", "Rasa", "Conversational AI", "LLMs"]
    },
    {
      id: 39,
      title: "Embedded Systems Developer",
      department: "Hardware Integration",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Develop embedded systems for educational hardware devices.",
      responsibilities: [
        "Develop firmware for educational hardware",
        "Interface with sensors and peripherals",
        "Implement communication protocols",
        "Optimize code for resource-constrained systems",
        "Debug hardware and software issues",
        "Collaborate with hardware engineers"
      ],
      requirements: [
        "3-5 years of embedded systems experience",
        "Strong proficiency in C/C++",
        "Experience with microcontrollers (ARM, ESP32)",
        "Knowledge of communication protocols (UART, I2C, SPI)",
        "Understanding of RTOS and embedded Linux",
        "Experience with debugging tools and oscilloscopes"
      ],
      qualifications: "B.Tech/B.E in Electronics, Computer Science, or related field",
      skills: ["C/C++", "Embedded Systems", "Microcontrollers", "RTOS", "Hardware Interface", "Firmware"]
    },
    {
      id: 40,
      title: "Performance Engineer",
      department: "Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "3-6 years",
      description: "Optimize application performance and ensure scalability.",
      responsibilities: [
        "Conduct performance testing and benchmarking",
        "Identify and resolve performance bottlenecks",
        "Optimize database queries and application code",
        "Implement caching strategies",
        "Monitor production performance metrics",
        "Create performance improvement recommendations"
      ],
      requirements: [
        "3-6 years of performance engineering experience",
        "Experience with performance testing tools (JMeter, Gatling)",
        "Strong knowledge of profiling and monitoring tools",
        "Understanding of system architecture and scalability",
        "Proficiency in at least one programming language",
        "Experience with load testing and stress testing"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Performance Testing", "JMeter", "Profiling", "Optimization", "Monitoring", "Scalability"]
    },
    {
      id: 41,
      title: "Accessibility Engineer",
      department: "Frontend Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Ensure our platform is accessible to all users including those with disabilities.",
      responsibilities: [
        "Implement WCAG 2.1 accessibility standards",
        "Conduct accessibility audits and testing",
        "Develop accessible UI components",
        "Create accessibility documentation and guidelines",
        "Use screen readers and assistive technologies",
        "Train developers on accessibility best practices"
      ],
      requirements: [
        "2-4 years of web development with accessibility focus",
        "Strong knowledge of WCAG 2.1 AA/AAA standards",
        "Experience with ARIA and semantic HTML",
        "Proficiency in accessibility testing tools",
        "Understanding of assistive technologies",
        "Certification in accessibility (IAAP) preferred"
      ],
      qualifications: "B.Tech/B.E or equivalent",
      skills: ["Accessibility", "WCAG", "ARIA", "Semantic HTML", "Screen Readers", "Web Standards"]
    },
    {
      id: 42,
      title: "Integration Engineer",
      department: "Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Build and maintain integrations with third-party systems and platforms.",
      responsibilities: [
        "Develop integrations with LMS and education platforms",
        "Implement SSO and authentication integrations",
        "Build data synchronization pipelines",
        "Create and maintain integration documentation",
        "Monitor integration health and performance",
        "Troubleshoot integration issues"
      ],
      requirements: [
        "3-5 years of integration development experience",
        "Experience with REST APIs and webhooks",
        "Knowledge of authentication protocols (OAuth, SAML)",
        "Proficiency in Node.js or Python",
        "Understanding of enterprise integration patterns",
        "Experience with iPaaS platforms (Zapier, Workato)"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["API Integration", "OAuth", "SAML", "Node.js", "Integration Patterns", "Webhooks"]
    },
    {
      id: 43,
      title: "SEO Specialist",
      department: "Marketing",
      location: "Remote",
      type: "Full-time",
      experience: "2-5 years",
      description: "Optimize our platform for search engines and drive organic traffic.",
      responsibilities: [
        "Conduct keyword research and competitive analysis",
        "Optimize on-page and technical SEO",
        "Build backlink strategies",
        "Monitor SEO metrics and rankings",
        "Create SEO content strategies",
        "Stay updated with search algorithm changes"
      ],
      requirements: [
        "2-5 years of SEO experience",
        "Strong knowledge of SEO tools (Ahrefs, SEMrush)",
        "Understanding of technical SEO and Core Web Vitals",
        "Experience with content optimization",
        "Knowledge of local and international SEO",
        "Analytical mindset with data-driven approach"
      ],
      qualifications: "B.Tech/BBA/MBA or equivalent",
      skills: ["SEO", "Keyword Research", "Technical SEO", "Content Strategy", "Analytics", "Link Building"]
    },
    {
      id: 44,
      title: "Learning Management System (LMS - EdTech/Vision Studio) Developer",
      department: "Platform Engineering",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-6 years",
      description: "Develop and customize our proprietary LMS platform.",
      responsibilities: [
        "Develop LMS features and functionality",
        "Customize Moodle or Canvas platforms",
        "Implement SCORM and xAPI standards",
        "Build reporting and analytics dashboards",
        "Integrate third-party tools and plugins",
        "Optimize LMS performance"
      ],
      requirements: [
        "3-6 years of LMS development experience",
        "Experience with Moodle, Canvas, or similar platforms",
        "Knowledge of e-learning standards (SCORM, xAPI)",
        "Proficiency in PHP, JavaScript, or Python",
        "Understanding of learning design principles",
        "Experience with database design for educational data"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["LMS Development", "Moodle", "SCORM", "xAPI", "PHP", "Educational Technology"]
    },
    {
      id: 45,
      title: "Network Engineer",
      department: "Infrastructure",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-6 years",
      description: "Design and maintain network infrastructure for optimal performance.",
      responsibilities: [
        "Design and implement network architecture",
        "Configure routers, switches, and firewalls",
        "Monitor network performance and security",
        "Troubleshoot network issues",
        "Implement VPN and security protocols",
        "Plan network capacity and scaling"
      ],
      requirements: [
        "3-6 years of network engineering experience",
        "Strong knowledge of TCP/IP, routing, and switching",
        "Experience with Cisco, Juniper, or similar equipment",
        "Understanding of network security best practices",
        "Relevant certifications (CCNA, CCNP) preferred",
        "Experience with SD-WAN and cloud networking"
      ],
      qualifications: "B.Tech/B.E in Computer Science, Electronics, or related field",
      skills: ["Networking", "TCP/IP", "Cisco", "Network Security", "VPN", "Troubleshooting"]
    },
    {
      id: 46,
      title: "Voice/Content UI/UX Developer",
      department: "Emerging Technologies",
      location: "Remote",
      type: "Full-time",
      experience: "2-4 years",
      description: "Build voice-enabled interfaces for hands-free learning experiences.",
      responsibilities: [
        "Develop voice applications for Alexa and Google Assistant",
        "Implement speech recognition and text-to-speech",
        "Design conversational voice experiences",
        "Optimize voice commands and responses",
        "Test voice interfaces across devices",
        "Integrate voice with existing platforms"
      ],
      requirements: [
        "2-4 years of voice UI development experience",
        "Experience with Alexa Skills Kit or Actions on Google",
        "Knowledge of speech recognition APIs",
        "Understanding of conversational design",
        "Proficiency in Node.js or Python",
        "Experience with NLP and voice analytics"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["Voice UI", "Alexa", "Google Assistant", "Speech Recognition", "Node.js", "Conversational Design"]
    },
    {
      id: 47,
      title: "IoT Developer",
      department: "Hardware Integration",
      location: "Hybrid",
      type: "Full-time",
      experience: "2-5 years",
      description: "Develop IoT solutions for smart classroom and educational devices.",
      responsibilities: [
        "Develop IoT applications and device firmware",
        "Implement device-to-cloud communication",
        "Build real-time data processing pipelines",
        "Implement security for IoT devices",
        "Develop device management systems",
        "Monitor and maintain IoT infrastructure"
      ],
      requirements: [
        "2-5 years of IoT development experience",
        "Experience with MQTT, CoAP, or similar protocols",
        "Knowledge of AWS IoT, Azure IoT Hub, or GCP IoT",
        "Proficiency in Python, C/C++, or JavaScript",
        "Understanding of edge computing",
        "Experience with sensors and microcontrollers"
      ],
      qualifications: "B.Tech/B.E in Computer Science, Electronics, or related field",
      skills: ["IoT", "MQTT", "AWS IoT", "Python", "Edge Computing", "Sensors"]
    },
    {
      id: 48,
      title: "Salesforce Developer",
      department: "CRM Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "3-5 years",
      description: "Customize and develop Salesforce solutions for our sales and student management.",
      responsibilities: [
        "Develop custom Salesforce applications using Apex and Lightning",
        "Create and maintain Salesforce integrations",
        "Build custom reports and dashboards",
        "Implement workflows and process automation",
        "Customize Salesforce Education Cloud",
        "Provide technical support and training"
      ],
      requirements: [
        "3-5 years of Salesforce development experience",
        "Proficiency in Apex, Visualforce, and Lightning components",
        "Experience with Salesforce Education Cloud (preferred)",
        "Knowledge of Salesforce APIs and integration tools",
        "Salesforce certifications (Platform Developer I/II)",
        "Understanding of CRM best practices"
      ],
      qualifications: "B.Tech/B.E or equivalent with Salesforce certifications",
      skills: ["Salesforce", "Apex", "Lightning", "Salesforce Integration", "CRM", "Process Automation"]
    },
    {
      id: 49,
      title: "WebRTC Engineer",
      department: "Live Streaming",
      location: "Hybrid",
      type: "Full-time",
      experience: "3-5 years",
      description: "Build real-time video communication features for live classes.",
      responsibilities: [
        "Develop WebRTC-based video conferencing solutions",
        "Implement screen sharing and whiteboard features",
        "Optimize video quality and bandwidth usage",
        "Handle NAT traversal and connection issues",
        "Integrate recording and streaming capabilities",
        "Debug and resolve media-related issues"
      ],
      requirements: [
        "3-5 years of WebRTC development experience",
        "Strong knowledge of WebRTC protocols and APIs",
        "Experience with media servers (Janus, Kurento, Jitsi)",
        "Proficiency in JavaScript and Node.js",
        "Understanding of network protocols and codecs",
        "Experience with video processing and streaming"
      ],
      qualifications: "B.Tech/B.E in Computer Science or related field",
      skills: ["WebRTC", "JavaScript", "Media Servers", "Video Streaming", "Node.js", "Real-time Communication"]
    },
    {
      id: 50,
      title: "Analytics Engineer",
      department: "Data Engineering",
      location: "Remote",
      type: "Full-time",
      experience: "2-5 years",
      description: "Build data models and analytics infrastructure for business insights.",
      responsibilities: [
        "Design and implement data models",
        "Build dbt models and transformations",
        "Create analytics dashboards and reports",
        "Implement data quality checks",
        "Collaborate with data analysts and scientists",
        "Document data models and metrics"
      ],
      requirements: [
        "2-5 years of analytics engineering experience",
        "Strong proficiency in SQL and data modeling",
        "Experience with dbt or similar tools",
        "Knowledge of data warehousing concepts",
        "Proficiency in Python for data manipulation",
        "Experience with BI tools (Looker, Tableau)"
      ],
      qualifications: "B.Tech/B.E in Computer Science, Statistics, or related field",
      skills: ["SQL", "dbt", "Data Modeling", "Python", "Data Warehousing", "BI Tools"]
    },
    {
      id: 51,
      title: "Junior AI Developer (Freshers)",
      department: "AI/ML",
      location: "Remote",
      type: "Full-time",
      experience: "0-1 year (Freshers with projects)",
      description: "Start your AI career working on real-world educational AI projects.",
      responsibilities: [
        "Assist in developing AI models under mentorship",
        "Implement machine learning algorithms",
        "Prepare datasets and perform data preprocessing",
        "Conduct experiments and document results",
        "Learn and apply new AI techniques",
        "Contribute to AI research initiatives"
      ],
      requirements: [
        "0-1 year of experience or strong academic projects in AI/ML",
        "Knowledge of Python and ML libraries (TensorFlow, PyTorch)",
        "Understanding of machine learning fundamentals",
        "Experience with at least 2-3 AI projects or internships",
        "Strong problem-solving and analytical skills",
        "Eagerness to learn and adapt to new technologies"
      ],
      qualifications: "B.Tech/B.E in Computer Science (2023-2024 graduates)",
      skills: ["Python", "Machine Learning", "TensorFlow", "Data Science", "Problem Solving", "Research"]
    }
  ];

  useEffect(() => {
    setFilteredJobs(jobListings);
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredJobs(jobListings);
    } else {
      const filtered = jobListings.filter(job =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.experience.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.skills.some(skill => skill.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredJobs(filtered);
    }
  }, [searchTerm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'jobApplications'), {
        ...formData,
        jobRole: selectedJob.title,
        appliedAt: new Date().toISOString(),
        status: 'pending'
      });
      setSubmitSuccess(true);
      setTimeout(() => {
        setShowModal(false);
        setShowApplicationForm(false);
        setSubmitSuccess(false);
        setFormData({
          name: '',
          email: '',
          mobile: '',
          experience: '',
          currentCompany: '',
          currentRole: '',
          noticePeriod: '',
          expectedSalary: '',
          portfolio: '',
          linkedin: '',
          github: '',
          skills: '',
          whyJoin: ''
        });
      }, 3000);
    } catch (error) {
      console.error("Error submitting application:", error);
      alert("Error submitting application. Please try again or contact us directly.");
    }
  };

  const openJobDetails = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowApplicationForm(false);
  };

  const openApplicationForm = () => {
    setShowApplicationForm(true);
  };

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="min-vh-100 my-5 py-5" style={{ backgroundColor: '#f8f9fa' }}>
        {/* Header Section */}
        <div className="text-white py-5" style={{ background: 'linear-gradient(135deg, #0d2384ff 0%, #000000ff 100%)' }}>
          <div className="container">
            <h1 className="display-4 fw-bold mb-3 animate__animated animate__fadeIn">
              Your Gateway to Research, Academia, and Industry Careers
            </h1>
            <p className="lead mb-4">
              Shape the future of education with cutting-edge technology, Empowering Talent for the Future Workforce
            </p>
            <div className="d-flex flex-wrap gap-3 small">
              <div className="d-flex align-items-center gap-2">
                <Briefcase size={20} />
                <span>50+ Open Positions</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <MapPin size={20} />
                <span>Remote, Hybrid & On-site</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Phone size={20} />
                <span>{contactNumber}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Mail size={20} />
                <span>{contactEmail}</span>
              </div>
              <Button className='bg-warning border-0  me-2 rounded-2' > <a className='text-white fw-bold' href="/company-internships"> Company Internships</a></Button>
              <Button className='bg-primary border-0 me-2 rounded-2' > <a className='text-white' href="/enroll">Enroll For Training</a></Button>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="container" style={{ marginTop: '-2rem' }}>
          <div className="card shadow-lg border-0 mb-4">
            <div className="card-body p-4">
              <div className="position-relative">
                <Search className="position-absolute" style={{ left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} size={20} />
                <input
                  type="text"
                  placeholder="Search by job title, skills, location, or experience..."
                  className="form-control form-control-lg ps-5"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="mt-3 text-muted small">
                {filteredJobs.length} positions found
              </div>
            </div>
          </div>
        </div>

        {/* Job Listings */}
        <div className="container pb-5">
          <div className="row g-4">
            {filteredJobs.map((job, index) => (
              <div key={job.id} className="col-12">
                <div className="card h-100 border-0 shadow-sm hover-shadow transition-all">
                  <div className="card-body p-4">
                    <div className="row">
                      <div className="col-lg-9 col-md-8">
                        <h3 className="card-title h5 fw-bold text-dark mb-3">
                          {job.title}
                        </h3>
                        <p className="card-text text-muted mb-3" style={{ 
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden'
                        }}>
                          {job.description}
                        </p>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                          <span className="badge bg-primary d-flex align-items-center gap-1">
                            <Briefcase size={14} />
                            {job.department}
                          </span>
                          <span className="badge bg-success d-flex align-items-center gap-1">
                            <MapPin size={14} />
                            {job.location}
                          </span>
                          <span className="badge bg-info d-flex align-items-center gap-1">
                            <Clock size={14} />
                            {job.experience}
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {job.skills.slice(0, 4).map((skill, idx) => (
                            <span key={idx} className="badge bg-light text-dark border">
                              {skill}
                            </span>
                          ))}
                          {job.skills.length > 4 && (
                            <span className="badge bg-light text-dark border">
                              +{job.skills.length - 4} more
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
                        <button
                          onClick={() => openJobDetails(job)}
                          className="btn btn-primary btn-lg fw-semibold w-100 w-md-auto"
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredJobs.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted fs-5">
                No jobs found matching your search. Try different keywords.
              </p>
            </div>
          )}
        </div>

        {/* Job Details Modal */}
        {showModal && selectedJob && (
          <div className="modal show d-block py-5 " style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header border-bottom">
                  <div>
                    <h2 className="modal-title h4 fw-bold mb-2">
                      {selectedJob.title}
                    </h2>
                    <div className="d-flex flex-wrap gap-2">
                      <span className="badge bg-primary d-flex align-items-center gap-1">
                        <Briefcase size={14} />
                        {selectedJob.department}
                      </span>
                      <span className="badge bg-success d-flex align-items-center gap-1">
                        <MapPin size={14} />
                        {selectedJob.location}
                      </span>
                      <span className="badge bg-info d-flex align-items-center gap-1">
                        <Clock size={14} />
                        {selectedJob.experience}
                      </span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn-close bg-danger"
                    onClick={closeModal}
                  ></button>
                </div>

                {!showApplicationForm ? (
                  <div className="modal-body">
                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Job Description</h3>
                      <p className="text-muted">{selectedJob.description}</p>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Key Responsibilities</h3>
                      <ul className="list-unstyled">
                        {selectedJob.responsibilities.map((item, idx) => (
                          <li key={idx} className="d-flex gap-2 mb-2">
                            <CheckCircle size={20} className="text-success flex-shrink-0 mt-1" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Requirements & Qualifications</h3>
                      <ul className="list-unstyled mb-3">
                        {selectedJob.requirements.map((item, idx) => (
                          <li key={idx} className="d-flex gap-2 mb-2">
                            <CheckCircle size={20} className="text-primary flex-shrink-0 mt-1" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                      <div className="alert alert-secondary">
                        <strong>Education:</strong> {selectedJob.qualifications}
                      </div>
                    </div>

                    <div className="mb-4">
                      <h3 className="h5 fw-bold mb-3">Required Skills</h3>
                      <div className="d-flex flex-wrap gap-2">
                        {selectedJob.skills.map((skill, idx) => (
                          <span key={idx} className="badge bg-gradient text-white px-3 py-2" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="alert alert-primary border-primary mb-4">
                      <h4 className="h6 fw-bold mb-2">Contact Information</h4>
                      <div className="d-flex flex-column gap-2 small">
                        <div className="d-flex align-items-center gap-2">
                          <Phone size={16} />
                          <span>Phone: {contactNumber}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Mail size={16} />
                          <span>Email: {contactEmail}</span>
                        </div>
                      </div>
                      <p className="small mb-0 mt-2">
                        Have questions? Feel free to reach out before applying!
                      </p>
                    </div>

                    <button
                      onClick={openApplicationForm}
                      className="btn btn-lg w-100 text-white fw-bold"
                      style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
                    >
                      Apply for this Position
                    </button>
                  </div>
                ) : (
                  <div className="modal-body">
                    {submitSuccess ? (
                      <div className="text-center py-5">
                        <CheckCircle size={64} className="text-success mb-3" />
                        <h3 className="h4 fw-bold mb-2">Application Submitted Successfully!</h3>
                        <p className="text-muted">
                          We'll review your application and get back to you soon.
                        </p>
                      </div>
                    ) : (
                      <>
                        <h3 className="h4 fw-bold mb-4">Apply for {selectedJob.title}</h3>
                        <form onSubmit={handleSubmit}>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Full Name *</label>
                              <input
                                type="text"
                                name="name"
                                required
                                value={formData.name}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="John Doe"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Email Address *</label>
                              <input
                                type="email"
                                name="email"
                                required
                                value={formData.email}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="john@example.com"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Mobile Number *</label>
                              <input
                                type="tel"
                                name="mobile"
                                required
                                value={formData.mobile}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="+91 9876543210"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Total Experience *</label>
                              <select
                                name="experience"
                                required
                                value={formData.experience}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">Select Experience</option>
                                <option value="0-1 years">0-1 years (Fresher)</option>
                                <option value="1-2 years">1-2 years</option>
                                <option value="2-3 years">2-3 years</option>
                                <option value="3-5 years">3-5 years</option>
                                <option value="5-7 years">5-7 years</option>
                                <option value="7+ years">7+ years</option>
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Current Company</label>
                              <input
                                type="text"
                                name="currentCompany"
                                value={formData.currentCompany}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Current Organization"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Current Role</label>
                              <input
                                type="text"
                                name="currentRole"
                                value={formData.currentRole}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Current Designation"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Notice Period</label>
                              <select
                                name="noticePeriod"
                                value={formData.noticePeriod}
                                onChange={handleInputChange}
                                className="form-select"
                              >
                                <option value="">Select Notice Period</option>
                                <option value="Immediate">Immediate</option>
                                <option value="15 days">15 days</option>
                                <option value="30 days">30 days</option>
                                <option value="60 days">60 days</option>
                                <option value="90 days">90 days</option>
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">Expected Salary (LPA)</label>
                              <input
                                type="text"
                                name="expectedSalary"
                                value={formData.expectedSalary}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g., 10-12 LPA"
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Portfolio/Website URL</label>
                              <input
                                type="url"
                                name="portfolio"
                                value={formData.portfolio}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://yourportfolio.com"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">LinkedIn Profile</label>
                              <input
                                type="url"
                                name="linkedin"
                                value={formData.linkedin}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://linkedin.com/in/yourprofile"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label fw-semibold">GitHub Profile</label>
                              <input
                                type="url"
                                name="github"
                                value={formData.github}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="https://github.com/yourusername"
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Key Skills *</label>
                              <textarea
                                name="skills"
                                required
                                value={formData.skills}
                                onChange={handleInputChange}
                                rows="3"
                                className="form-control"
                                placeholder="e.g., React.js, Node.js, Python, AWS, etc."
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label fw-semibold">Why do you want to join our Ed-Tech Academy? *</label>
                              <textarea
                                name="whyJoin"
                                required
                                value={formData.whyJoin}
                                onChange={handleInputChange}
                                rows="4"
                                className="form-control"
                                placeholder="Tell us what excites you about this opportunity..."
                              />
                            </div>
                          </div>
                          <div className="d-flex gap-3 mt-4">
                            <button
                              type="button"
                              onClick={() => setShowApplicationForm(false)}
                              className="btn btn-secondary btn-lg flex-fill"
                            >
                              Back to Job Details
                            </button>
                            <button
                              type="submit"
                              className="btn btn-lg flex-fill text-white fw-semibold"
                              style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
                            >
                              Submit Application
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Footer Info */}
        <div className="bg-light py-5 border-top">
          <div className="container text-center">
            <h3 className="h4 fw-bold mb-3">
              Ready to Shape the Future of Education?
            </h3>
            <p className="text-muted mb-4">
              Join our team of innovators working on 200+ cutting-edge Ed-Tech projects
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3 small">
              <span className="badge bg-success">✅ Competitive Compensation</span>
              <span className="badge bg-success">✅ Work-Life Balance</span>
              <span className="badge bg-success">✅ Learning & Growth</span>
              <span className="badge bg-success">✅ Innovative Projects</span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          transform: translateY(-2px);import { Link } from 'react-router-dom';

        }
        .transition-all {
          transition: all 0.3s ease;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate__animated {
          animation-duration: 0.6s;
        }
        .animate__fadeIn {
          animation-name: fadeIn;
        }
        .card {
          animation: slideIn 0.4s ease-out;
        }
        .modal.show {
          display: block;
          animation: fadeIn 0.3s ease-out;
        }
        .badge {
          font-weight: 500;
        }
        .btn-primary, .btn-lg {
          transition: all 0.3s ease;
        }
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .form-control:focus, .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);
        }
        .list-unstyled li {
          padding: 0.5rem 0;
        }
        .bg-gradient {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
      `}</style>

      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default JobsPortal;